import { endpoints } from "../endpoints";
import { TestingSet } from "./testingSet";

const testingEndpoints = [
  endpoints.externalCpd.add,
  endpoints.searchTile.query
]

export const defaultTestingSet = new TestingSet('default testing set', testingEndpoints)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/testingSets/defaultTestingSet.js